import { useEffect, useRef, useState } from 'react';
import { Carousel as NativeCarousel } from '@fancyapps/ui';
import '@fancyapps/ui/dist/carousel/carousel.css';

import {
    getAdvertisementData,
    selectAdvertisements
} from 'features/advertisement/advertisementSlice';
import {
    useAppDispatch,
    useAppSelector,
} from 'app/hooks';
import AdvtSlider from './AdvtSlider';

const AdvtPage = () => {
    const [oneArr, setOneArr] = useState([]);
    const [twoArr, setTwoArr] = useState([]);
    const [threeArr, setThreeArr] = useState([]);
    const [fourArr, setFourArr] = useState([]);
    
    const containerRef = useRef(null);
    const {
        advtData
    } = useAppSelector(selectAdvertisements);

    const filterAdvt = (arr=[], filterValue='') => {
        return arr.filter((item:any) => item.position === filterValue)
    }
    useEffect(() => {
        let oneAdvt = filterAdvt(advtData, 'One');
        let twoAdvt = filterAdvt(advtData, 'Two');
        let threeAdvt = filterAdvt(advtData, 'Three');
        let fourAdvt = filterAdvt(advtData, 'Four');
        setOneArr(oneAdvt)
        setTwoArr(twoAdvt)
        setThreeArr(threeAdvt)
        setFourArr(fourAdvt)
    }, [advtData])
    useEffect(() => {
        const container = containerRef.current;

        if (container) {
            const options = {
                infinite: true,
                Navigation: {
                    dots: false // Hide dots
                }
            };
            const instance = new NativeCarousel(container, options);
            const autoplayInterval = setInterval(() => {
                instance.slideNext();
            }, 3000); // Change slide every 3 seconds

            return () => {
                if (instance) instance.destroy();
                clearInterval(autoplayInterval);
            };
        }
    });

    return (
        <div className={"row advt"}>
            {oneArr.length > 0 && <div className="col-lg-6 col-md-6 col-6 col-xs-6 mb-4">
                <AdvtSlider data={oneArr}/>
            </div>}
            {twoArr.length > 0 && <div className="col-lg-6 col-md-6 col-6 col-xs-6 mb-4">
                <AdvtSlider data={twoArr}/>
            </div>}
            {threeArr.length > 0 && <div className="col-lg-6 col-md-6 col-6 col-xs-6 mb-4">
                <AdvtSlider data={threeArr}/>
            </div>}
            {fourArr.length > 0 && <div className="col-lg-6 col-md-6 col-6 col-xs-6 mb-4">
                <AdvtSlider data={fourArr}/>
            </div>}
        </div>
    );
}

export default AdvtPage;
